import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import * as AssetPageFeature from 'marketplace-ui-assets-core/constants/AssetPageFeature';
import { Fragment } from 'react';
import { useOfferingType } from '../../../context/OfferingTypeContext';
import { useStorefrontRouteParamTranslations } from '../../../storefront/hooks/useStorefrontRouteParamTranslations';
import { getCmsHubProductUrl } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
function getJSXMessageProps(options = {}) {
  return {
    elements: {
      Link
    },
    options: Object.assign({}, options, {
      linkProps: {
        href: getCmsHubProductUrl()
      }
    })
  };
}
function ThemesResultsHeaderDescription({
  description,
  routeParams,
  searchTerm
}) {
  const {
    businessType,
    pageType,
    pageFeature
  } = routeParams;
  const {
    businessType: businessTypeText,
    pageType: pageTypeText,
    pageFeature: pageFeatureText
  } = useStorefrontRouteParamTranslations(routeParams, 'lower');
  if (searchTerm) {
    return null;
  }
  if (description) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: description
    });
  }
  if (businessType && pageType) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({}, getJSXMessageProps({
      businessType: businessTypeText,
      pageType: pageTypeText
    }), {
      message: "marketplace-assets-ui.themes.resultsHeader.description.businessTypePageType_jsx"
    }));
  }
  if (businessType && pageFeature) {
    switch (pageFeature) {
      case AssetPageFeature.PARALLAX:
        return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({}, getJSXMessageProps({
          businessType: businessTypeText
        }), {
          message: "marketplace-assets-ui.themes.resultsHeader.description.businessTypePageFeature.PARALLAX_jsx"
        }));
      default:
        return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({}, getJSXMessageProps({
          businessType: businessTypeText,
          pageFeature: pageFeatureText
        }), {
          message: "marketplace-assets-ui.themes.resultsHeader.description.businessTypePageFeature.defaultDescription_jsx"
        }));
    }
  }
  if (pageType && pageFeature) {
    switch (pageFeature) {
      case AssetPageFeature.PARALLAX:
        return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({}, getJSXMessageProps({
          pageType: pageTypeText
        }), {
          message: "marketplace-assets-ui.themes.resultsHeader.description.pageTypePageFeature.PARALLAX_jsx"
        }));
      default:
        return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({}, getJSXMessageProps({
          pageType: pageTypeText,
          pageFeature: pageFeatureText
        }), {
          message: "marketplace-assets-ui.themes.resultsHeader.description.pageTypePageFeature.defaultDescription_jsx"
        }));
    }
  }
  if (businessType || pageType || pageFeature) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({}, getJSXMessageProps({
      category: businessTypeText || pageTypeText || pageFeatureText
    }), {
      message: "marketplace-assets-ui.themes.resultsHeader.description.singleCategory_jsx"
    }));
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({}, getJSXMessageProps(), {
    message: "marketplace-assets-ui.themes.resultsHeader.description.default_jsx"
  }));
}
function ModulesResultsHeaderDescription({
  description,
  searchTerm
}) {
  if (searchTerm) {
    return null;
  }
  if (description) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: description
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.modules.resultsHeader.description.default"
  });
}
export function AssetResultsHeaderDescription(props) {
  const offeringType = useOfferingType();
  if (offeringType === 'THEME') {
    return /*#__PURE__*/_jsx(ThemesResultsHeaderDescription, Object.assign({}, props));
  } else {
    return /*#__PURE__*/_jsx(ModulesResultsHeaderDescription, Object.assign({}, props));
  }
}